<template>
    <FooterAdminTools v-if="isLoggedAsAdmin">
        <h4>Elasticsearch queries</h4>
        <ul>
            <li v-if="initialSearchResponse?.query">
                Initial search:
                <AdminShowQueryButton :query="initialSearchResponse?.query" />
            </li>
            <li v-if="remoteFallbackSearchResponse?.query">
                Remote fallback search:
                <AdminShowQueryButton :query="remoteFallbackSearchResponse?.query" />
            </li>
            <li v-if="europaFallbackSearchResponse?.query">
                Europa fallback search:
                <AdminShowQueryButton :query="europaFallbackSearchResponse?.query" />
            </li>
        </ul>
    </FooterAdminTools>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {FooterAdminTools} from '#components';
    import {useAuth, useHasEnoughPriviledge} from '#imports';
    import AdminShowQueryButton from './AdminShowQueryButton.vue';
    import {useProfilesStore} from '../stores/profiles.store';

    const isAdmin = await useHasEnoughPriviledge(['ROLE_ADMIN']);
    const authStore = useAuth();
    const {loggedIn} = storeToRefs(authStore);
    const isLoggedAsAdmin = computed(() => loggedIn && isAdmin);
    const profilesStore = useProfilesStore();
    const {initialSearchResponse, remoteFallbackSearchResponse, europaFallbackSearchResponse} = storeToRefs(profilesStore);
</script>
